import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function MeetingJoinPage() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    api.post("/meetings/join-by-code", { code })
      .then(({ data }) => navigate(`/meeting/${data.id}`, { replace: true }))
      .catch((e) => {
        toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Invalid or expired meeting link");
        navigate("/meetings", { replace: true });
      });
  }, [code, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="meeting-join-link-loading">
      <div className="w-10 h-10 border-2 border-accent border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
